import { AlertCircle, CheckCircle, CircleCheckIcon, Download, FileArchive, Hourglass, Info, Key, List, OctagonAlert, Repeat, RotateCw, SendIcon, TriangleAlert, X } from "lucide-react";

export const gaIconMap: Record<string, React.ElementType> = {
    "vismaicon vismaicon-sm ar-send": SendIcon,
    "vismaicon vismaicon-sm vismaicon-refresh": RotateCw,
    "vismaicon vismaicon-sm ar-archive": FileArchive,
    "ar-close close mr-8 mr-0": X,
    "vismaicon vismaicon-sm ar-replace": Repeat,
    "vismaicon vismaicon-sm ar-download": Download,
    "vismaicon vismaicon-sm vismaicon-list-view-1": List
};


export const gaIconColorMap: Record<string, string> = {
    "ar-close close mr-8 mr-0": "var(--ga-color-error)",
};


export const gaButtonClassNameMap: Record<string, string> = {
    "btn btn-primary": "ga-button ga-button--primary",
    "btn-primary": "ga-button ga-button--primary",
    "btn-default": "ga-button ga-button--secondary",
}


export const gaRreportStatusIconMap: Record<string, { icon: React.ElementType, size: number, color: string }> = {
    Received: {
        icon: SendIcon,
        size: 16,
        color: "var(--ga-color-icon-primary)",
    },
    ErrorInReport: {
        icon: AlertCircle,
        size: 16,
        color: "var(--ga-color-icon-error)",
    },
    InProgress: {
        icon: Hourglass,
        size: 16,
        color: "var(--ga-color-icon-primary)",
    },
    ErrorLogOn: {
        icon: Key,
        size: 16,
        color: "var(--ga-color-icon-error)",
    },
    Completed: {
        icon: CheckCircle,
        size: 16,
        color: "var(--ga-color-icon-success)",
    },
    Canceled: {
        icon: X,
        size: 16,
        color: "var(--ga-color-icon-error)"
    },
    SendingFailed: {
        icon: SendIcon,
        size: 16,
        color: "var(--ga-color-icon-error)",
    },
};

export const getReportStatusIcon = (reportStatusGroup: string) => {
    return gaRreportStatusIconMap[reportStatusGroup];
};

export const getGaAlertIcon = (type: string, className: string) => {
    const iconMap: Record<string, React.ElementType> = {
        success: CircleCheckIcon,
        warning: TriangleAlert,
        error: OctagonAlert,
        information: Info,
    };

    const IconComponent = iconMap[type];
    if (!IconComponent) 
        return null;

    return <IconComponent className={`ga-notification__icon ${className}`} color={`var(--ga-color-icon-${type})`} />;
};
